import styled from 'styled-components';

export const SubActionButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
`;
